module.exports = __webpack_public_path__ + "img/aboutTop.2ba856df.png";